module.exports = __webpack_public_path__ + "img/cross-red.811334ee.png";